import Factory from '../factory';
import {Collection, Schema} from "@oilstone/rest-model-repository";

const schema = Factory.schema('image-carousel');
const attributes = schema.getProp('attributes').getValue();
const item = new Schema();

item.prop('src').setType(String).setValue('image-placeholder.svg');
item.prop('alt').setType(String);

attributes.prop('items').setType(Collection).setValue(new Collection(item));

export default schema;
